<template>
  <div class="section">
    <!-- 주문 상품 정보 -->
    <div class="order-info">
      <div class="order-info--tit">주문 상품 정보</div>
      <div v-for="(data, index) in option" :key="index" class="order-info--card">
        <div class="name">[{{ item.brand }}] {{ item.product_name }}</div>
        <div class="option">
          옵션/수량 : {{ data.label1 }} <span v-if="data.label2">[ {{ data.label2 }} ]</span> /
          {{ data.cnt }}개
        </div>
        <div class="price">{{ _formatAmount(data.cnt * (data.addAmount + price)) }}원</div>
      </div>
    </div>

    <!-- 주문자 정보 -->
    <div class="order-info">
      <div class="order-info--tit">주문자 정보</div>
      <div class="order-info--row">
        <span class="label">이름<span class="required">*</span></span>
        <span class="value"
          ><input
            v-model="userInfo.name"
            type="text"
            class="input-form"
            required
            @input="onNoEmojiInput('userInfo.name', $event)"
        /></span>
      </div>
      <div class="order-info--row">
        <span class="label">
          연락처<span class="required">*</span>
          <span class="sm">입력하신 연락처로<br />주문번호가 전송됩니다.</span>
        </span>
        <span class="value"
          ><input
            v-model="userInfo.phone"
            type="tel"
            class="input-form"
            required
            @input="onPhoneInput('userInfo.phone', $event)"
        /></span>
      </div>
      <div class="order-info--row">
        <span class="label">이메일</span>
        <span class="value"
          ><input
            v-model="userInfo.email"
            type="email"
            class="input-form"
            @input="onNoEmojiInput('userInfo.email', $event)"
        /></span>
      </div>
    </div>

    <!-- 배송지 정보 -->
    <div class="order-info">
      <div class="order-info--tit">
        <span class="label-width">배송지 정보</span>
        <label class="input-check">
          <input
            type="checkbox"
            @change="
              event => {
                if (event.target.checked) {
                  // 체크되었을 때
                  userInfo.address.name = userInfo.name;
                  userInfo.address.phone = userInfo.phone;
                }
              }
            "
          />
          <span class="check"></span>
          <span class="text">주문자 정보와 동일</span>
        </label>
      </div>
      <div class="order-info--row">
        <span class="label">수령인<span class="required">*</span></span>
        <span class="value"
          ><input
            v-model="userInfo.address.name"
            type="text"
            class="input-form"
            required
            @input="onNoEmojiInput('userInfo.address.name', $event)"
        /></span>
      </div>
      <div class="order-info--row">
        <span class="label">연락처<span class="required">*</span></span>
        <span class="value"
          ><input
            v-model="userInfo.address.phone"
            type="tel"
            class="input-form"
            required
            @input="onPhoneInput('userInfo.address.phone', $event)"
        /></span>
      </div>
      <div class="order-info--row type2">
        <span class="label">주소<span class="required">*</span></span>
        <span class="value">
          <input
            v-model="userInfo.address.address"
            type="text"
            class="input-form"
            required
            disabled
          />
          <button type="button" class="btn btn-grey" @click="openPostcode">검색</button>
        </span>
      </div>
      <div class="order-info--row">
        <span class="label"></span>
        <span class="value"
          ><input
            v-model="userInfo.address.address2"
            type="text"
            class="input-form"
            placeholder="상세 주소 입력"
            @input="onNoEmojiInput('userInfo.address.address2', $event)"
        /></span>
      </div>
      <div class="order-info--row">
        <span class="label">배송 메시지</span>
        <span class="value"
          ><input
            v-model="userInfo.address.message"
            type="text"
            class="input-form"
            @input="onNoEmojiInput('userInfo.address.message', $event)"
        /></span>
      </div>
    </div>

    <!-- 결제 정보 -->
    <div class="order-info">
      <div class="order-info--tit">결제정보</div>
      <div class="order-info--row">
        <span class="label">상품 금액</span>
        <span class="value product-amount">{{ _formatAmount(total) }}원</span>
      </div>
      <div class="order-info--row">
        <span class="label">
          배송비
          <span v-if="delivery.free !== 999999" class="sm">{{ _formatAmount(delivery.free) }}원 이상 구매시 무료배송</span>
        </span>
        <span class="value shipping-fee"
          >{{ _formatAmount(delivery.default + delivery.add) }}원</span
        >
      </div>
      <div class="order-info--row">
        <span class="label">총 결제금액</span>
        <span class="value total-amount">{{ _formatAmount(payTotal) }}원</span>
      </div>
      <div class="order-info--row" style="display: none;">
        <span class="label">결제수단<span class="required">*</span></span>
        <span class="value">
          <div class="select-wrap">
            <select class="input-form" disabled required>
              <option value="card">카드</option>
            </select>
          </div>
        </span>
      </div>
    </div>

    <!-- 동의 및 결제 -->
    <div class="order-agree">
      <div class="notice-warning">
        ※ BC카드 (우리BC, 기업BC 등), 국민은행 계열 카드(국민, 카카오, 페이코 등)는 일반 결제만
        가능하며,<br />네이버페이를 통한 결제는 지원되지 않습니다.
      </div>
      <div class="flex">
        <label class="input-check">
          <input v-model="isChecked" type="checkbox" />
          <span class="check"></span>
          <span class="text">주문 내용을 확인했으며, 결제에 동의합니다.</span>
        </label>
        <!-- <button class="btn btn-text" @click="openModal">약관보기</button> -->
      </div>
      <button class="btn btn-lg btn-primary" @click="handleBuyClick">
        {{ _formatAmount(payTotal) }}원 결제하기
      </button>
    </div>

    <!-- Postcode 모달 -->
    <div class="modal" :class="{ isVisible: modal.postal }">
      <div class="dim" @click="closeModal('postal')"></div>
      <div class="popup pop_yellow">
        <button class="btn popup_close" @click="closeModal('postal')">&times;</button>
        <div class="pop">
          <strong class="txt_medium tit">주소 검색</strong>
          <div class="pop_review_txt">
            <div ref="postcodeLayer" style="width: 100%; height: 500px"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" :class="{ isVisible: modal.use }">
      <div class="dim"></div>
      <div class="popup pop_yellow">
        <button class="btn popup_close" @click="closeModal('use')">&times;</button>
        <div class="pop">
          <strong class="txt_medium tit">이용약관</strong>
          <div class="pop_review_txt">약관내용</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global daum */
</script>
<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import Footer from '@/components/Footer.vue';
import {
  _formatAmount,
  _getStorageWithExpiry,
  _getIsGonggu,
  _getIsPassed,
  _setStorageWithExpiry,
  _safeAtob,
} from '../utils/common.js';
import Cookies from 'js-cookie';
import api from '@/utils/api.js';
import { gaEvent } from '@/utils/ga.js';

const item = JSON.parse(history.state.item);
const option = JSON.parse(history.state.option);
const storedSId = _getStorageWithExpiry('sId');
const bId = _getStorageWithExpiry('b_id');
const storedId = _safeAtob(_getStorageWithExpiry('id'));

const price = Number(
  _getIsGonggu() && !_getIsPassed(item.var2, item.var3, item.open_time)
    ? item.selling_price
    : item.retail_price,
);

const orderId = ref('');
const postcodeLayer = ref(null);

const modal = reactive({
  use: false,
  postal: false,
});

function updateTotalPrices() {
  option.forEach(data => {
    data.totalPrice = Math.floor((price + Number(data.addAmount)) * data.cnt);
  });
  console.log('옵션 가격 업데이트:', option);
}

const total = computed(() => {
  updateTotalPrices();
  return option.reduce((sum, item) => sum + item.totalPrice, 0);
});
const payTotal = computed(() => {
  updateTotalPrices();
  return option.reduce((sum, item) => sum + item.totalPrice, 0) + (delivery.default + delivery.add);
});

const isFormValid = computed(() => {
  return (
    userInfo.name.trim() !== '' &&
    userInfo.phone.trim() !== '' &&
    userInfo.address.name.trim() !== '' &&
    userInfo.address.phone.trim() !== '' &&
    userInfo.address.address.trim() !== ''
  );
});

const isChecked = ref(false);
const router = useRouter();

onMounted(() => {
  window.scrollTo(0, 0);
  // window.addEventListener('beforeunload', handleBeforeUnload);
  getDeliveryData();
});

function isValidPhone(phone) {
  return /^010-\d{4}-\d{4}$/.test(phone);
}

function openModal(type) {
  modal[type] = true;
}
function closeModal(type) {
  modal[type] = false;
}

const userInfo = reactive({
  name: '',
  phone: _safeAtob(_getStorageWithExpiry('hp')),
  email: '',
  address: {
    name: '',
    phone: '',
    address: '',
    address2: '',
    postal_code: '',
    message: '',
  },
  freeShipping: '',
});

const delivery = reactive({
  default: '',
  free: '',
  add: 0,
});

// Remove emoji / pictographic characters (including variation selectors and ZWJ sequences)
const EMOJI_REGEX = /[\p{Extended_Pictographic}\uFE0F\u200D]/gu;

function removeEmoji(value) {
  return String(value ?? '').replace(EMOJI_REGEX, '');
}

function onNoEmojiInput(path, event) {
  const raw = event?.target?.value ?? '';
  const cleaned = removeEmoji(raw);

  // If we removed something, reflect it immediately in the input UI
  if (event?.target && cleaned !== raw) {
    event.target.value = cleaned;
  }

  switch (path) {
    case 'userInfo.name':
      userInfo.name = cleaned;
      break;
    case 'userInfo.phone':
      userInfo.phone = cleaned;
      break;
    case 'userInfo.email':
      userInfo.email = cleaned;
      break;
    case 'userInfo.address.name':
      userInfo.address.name = cleaned;
      break;
    case 'userInfo.address.phone':
      userInfo.address.phone = cleaned;
      break;
    case 'userInfo.address.address2':
      userInfo.address.address2 = cleaned;
      break;
    case 'userInfo.address.message':
      userInfo.address.message = cleaned;
      break;
    default:
      break;
  }
}

function openPostcode() {
  const container = postcodeLayer.value;
  if (!container) return;

  openModal('postal');

  // 기존 내용 초기화
  container.innerHTML = '';

  new daum.Postcode({
    oncomplete(data) {
      userInfo.address.postal_code = data.zonecode;
      userInfo.address.address = data.roadAddress;
      checkAddress(data.zonecode);
      closeModal('postal');
    },
    width: '100%',
    height: '100%',
  }).embed(container);
}

const getOrderId = async () => {
  const response = await api.post('/order.php', {
    mode: 'orderId',
    type: 'G',
    idnt_code: storedId,
  });
  orderId.value = response.data.data;
};

async function handleBuyClick() {
  if (!isFormValid.value) {
    alert('필수 항목을 모두 입력해주세요.');
    return;
  } else if (!isChecked.value) {
    alert('결제를 진행하려면 동의가 필요합니다.');
    return;
  }
  if (!isValidPhone(userInfo.phone) || !isValidPhone(userInfo.address.phone)) {
    alert('연락처 형식이 올바르지 않습니다.');
    return;
  }

  await getOrderId();
  const marketAddResult = await tempPayMarketProduct();

  if (marketAddResult.result !== 'SUCCESS') {
    alert(marketAddResult.message || '결제에 실패하였습니다. 관리자에게 문의바랍니다.');
    return;
  }

  const redirectUrl =
    // `https://tble-shop.3alliance.co.kr/payResult` +
    `${process.env.VUE_APP_PAY_REDIRECT_URL}` +
    `?s_id=${encodeURIComponent(storedSId)}` +
    `&id=${encodeURIComponent(storedId)}` +
    `&productId=${item.goods_code}` +
    `&productName=${item.product_name}` +
    `&orderId=${orderId.value}`;

  gaEvent('begin_checkout', {
    page_name: 'payment',
    product_id: item.product_id,
    product_name: item.product_name,
    order_id: orderId.value,
  });

  // 테스트 channel-key-ff09e9a9-c180-4c92-b737-4fb231878192
  // 실제 channel-key-b9d204be-8e3d-47e9-b937-bd05edaa0ad2
  const { IMP } = window;
  //IMP.agency('imp13611471', 'TBL');
  IMP.init('imp13611471');
  IMP.request_pay(
    {
      channelKey: process.env.VUE_APP_PAY_KEY,
      pay_method: 'card',
      merchant_uid: 'order_id_' + new Date().getTime(),
      name: `[공구구매] ${item.product_name}`,
      amount: payTotal.value,
      buyer_email: userInfo.email,
      buyer_name: userInfo.address.name,
      buyer_tel: userInfo.address.phone,
      m_redirect_url: redirectUrl,
      test: true,
      //m_redirect_url: 'http://192.168.200.187:8080/payResult',
      // tierCode: 'TBL',
    },
    function (rsp) {
      if (rsp.success) {
        gaEvent('purchase', {
          product_id: item.product_id,
          product_name: item.product_name,
          order_id: orderId.value,
          pg: rsp.pg_provider,
          pay_method: rsp.pay_method,
        });
        payMarketProduct(rsp);
      } else {
        gaEvent('purchase_fail', {
          product_id: item.product_id,
          product_name: item.product_name,
          reason: rsp.error_msg || 'cancel',
        });
      }
    },
  );
  console.log(IMP);
}

const tempPayMarketProduct = async () => {
  const transformedOption = option.map(data => ({
    cnt: data.cnt,
    inven_idx: data.invenIdx,
    amount_once: data.totalPrice,
    usedPoint: 0,
    goods_code: item.goods_code,
  }));

  const param = {
    mode: 'marketAdd',
    type: 'G',
    orderList: transformedOption,
    amount: payTotal.value,
    name: userInfo.address.name,
    address: userInfo.address.address,
    address2: userInfo.address.address2,
    postal_code: userInfo.address.postal_code,
    phone: (userInfo.address.phone || '').replace(/-/g, ''),
    message: userInfo.address.message,
    payment_way: 'card',
    imp_uid: 'false',
    market_delivery_status_id: '5',
    total_count: option.reduce((sum, item) => sum + item.cnt, 0),
    order_id: orderId.value,
    usedCash: payTotal.value,
    address_name: '배송지',
    delivery_charge: delivery.default + delivery.add,
    idnt_code: storedId,
    s_idnt_code: storedSId,
    usedPoint: 0,
    b_id: bId,
    o_name: userInfo.name,
    o_phone: (userInfo.phone || '').replace(/-/g, ''),
    o_email: userInfo.email,
  };

  const response = await api.post('/order.php', param);
  return response.data;
};

const payMarketProduct = async payResult => {
  getOrderCode(payResult.imp_uid);
};

function onPhoneInput(path, event) {
  const e = event;
  let value = e?.target?.value ?? '';
  let result = '';

  value = String(value).replace(/\D/g, '');

  if (value.length > 11) {
    value = value.slice(0, 11);
  }

  if (value.length <= 3) {
    result = value;
  } else if (value.length <= 7) {
    result = `${value.slice(0, 3)}-${value.slice(3)}`;
  } else {
    result = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
  }

  if (e?.target) e.target.value = result;

  if (path === 'userInfo.phone') {
    userInfo.phone = result;
  } else if (path === 'userInfo.address.phone') {
    userInfo.address.phone = result;
  }
}

async function getOrderCode(impUid) {
  const response2 = await api.post('/order.php', {
    mode: 'marketUpdate',
    storedId: storedSId,
    imp_uid: impUid,
    order_id: orderId.value,
    idnt_code: storedId,
  });

  router.push({
    path: '/orderComplete',
    state: {
      orderId: orderId.value,
    },
  });
}

async function getDeliveryData() {
  const response = await api.post('/auth.php', {
    goods_code: item.goods_code,
  });

  delivery.default =
    total.value >= response.data.data.shipping_free_tble ? 0 : Number(response.data.data.shipping);
  delivery.free = Number(response.data.data.shipping_free_tble);
}

async function checkAddress(postalCode) {
  const response = await api.post('/tble.php', {
    mode: 'area',
    post_code: postalCode,
    idnt_code: storedId,
    productId: item.goods_code,
  });

  delivery.add = Number(response.data?.data?.price || 0);
}
</script>
